<template>
    <drawer title="Metadata" class="flex-metadat-editor">
        <div class="flex-metadata-container">
            <button class="flex-metadata-editor__button" @click="openCM">
                Open in Sitecore
            </button>

            <page-data
                submit-button-text="SUBMIT"
                :data="pageDataNew"
                :edit-mode="true"
                @save="onSave"
                @cancel="hideDrawer"
            />
        </div>
    </drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { PageData as PageDataModel } from '@/data/data-models';

import Drawer from '@/components/shared/drawer/drawer';
import PageData from '@/components/page-editor/shared/page-data';
import { SET_PAGE_DATA, SET_CHANGED_DATA, HIDE_DRAWER } from '@/store/types/mutation-types';

export default {
    name: 'metadata-editor',
    components: { Drawer, PageData },

    data() {
        return {
            pageDataNew: {},
        };
    },

    computed: {
        ...mapState({
            pageData: state => state.page.pageData,
        }),
    },

    watch: {
        pageData: {
            handler(val) {
                this.setData(val);
            },
            immediate: true,
        },
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
            setChangedData: SET_CHANGED_DATA,
            setPageData: SET_PAGE_DATA,
        }),

        openCM() {
            const itemid = this.pageData.pageData.id;
            const lang = this.pageData.pageData.language;
            const cmurl = `${ process.env.VUE_APP_CM_URL }/sitecore/shell/sitecore/content/Applications/Content Editor.aspx?id=${ itemid }&la=${ lang }&fo=${ itemid }`;
            window.open(cmurl);
        },

        onSave(updatedPageData) {
            const currentPageData = this.pageData;
            currentPageData.pageData = {
                ...currentPageData.pageData,
                itemName: updatedPageData.name,
                articleSummary: updatedPageData.articleSummary,
                mainTitle: updatedPageData.mainTitle,
                browserTitle: updatedPageData.browserTitle,
                metaDescription: updatedPageData.metaDescription,
                metaKeywords: updatedPageData.metaKeywords,
                isPrototype: updatedPageData.isPrototype,
                noIndex: updatedPageData.noIndex,
                noFollow: updatedPageData.noFollow,
                noArchive: updatedPageData.noArchive,
                noSnippet: updatedPageData.noSnippet,
            };

            this.setPageData(currentPageData);
            this.setChangedData(true);

            this.hideDrawer();
        },

        setData(data) {
            if (data) {
                this.pageDataNew = new PageDataModel({
                    name: data.pageData.itemName,
                    templateName: data.layout.pageTemplateName,
                    articleSummary: data.pageData.articleSummary,
                    mainTitle: data.pageData.mainTitle,
                    browserTitle: data.pageData.browserTitle,
                    metaDescription: data.pageData.metaDescription,
                    metaKeywords: data.pageData.metaKeywords,
                    bodyClasses: data.pageData.bodyClasses,
                    noIndex: data.pageData.noIndex,
                    noFollow: data.pageData.noFollow,
                    noArchive: data.pageData.noArchive,
                    noSnippet: data.pageData.noSnippet,
                    isPrototype: data.pageData.isPrototype,
                });
            }
        },
    },
};
</script>

<style lang="scss">
.flex-metadata-editor {
    overflow-y: auto;

    &__button {
        padding: 7px 15px;
        margin-left: 35px;
        margin-top: 10px;
        border-radius: 4px;
        font-size: 13px;
        color: var(--form-buttonColor);
        background-color: var(--form-buttonBackgroundColor);
        min-width: 100px;
    }

    .flex-metadata-container {
        min-width: 100%;
        height: calc(100vh - 83px - 50px); // 83 is top bar, 50 is buttons on bottom
        overflow-y: auto;
        padding: 20px 0;
    }
}
</style>
